import { useState, useEffect, useRef } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDButton from "components/MDButton";
import MDAvatar from "components/MDAvatar";
import Tooltip from "@mui/material/Tooltip";
import Swal from "sweetalert2";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
 import { CircularProgress } from "@mui/material";
// import { capitalizeFirstLetter } from "examples/CommonFunctions";
// @mui material components
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Add } from "@mui/icons-material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
// Material Dashboard 2 React examples
import DataTable from "examples/Tables/DataTable";
// import { createApiAction } from "store/ApiServices";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import profileDefault from "assets/images/Profile-default.jpg";
import { IconButton } from "@mui/material";
import { SearchOutlined } from "@mui/icons-material";
//dialog
import {
  TextField,
} from "@mui/material";

import Pagination from "@mui/material/Pagination";
import { formatDate } from "utils/formatData";
import { baseUrl } from "services/axiosInstance";
import { getUsersData } from "../../redux/slices/userDataSlice";
import { capitalizeFirstLetter } from "utils/formatData";

function UserTable() {
  const navigate = useNavigate();
  const [menu, setMenu] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const dispatch = useDispatch();
  const openMenu = ({ currentTarget }) => setMenu(currentTarget);
  const closeMenu = () => setMenu(null);
  // const userData = useSelector((state) => state.apiData.data.data)
  const userData = useSelector((state) => state.userData.userData);
  const totalCount = useSelector((state) => state.userData.totalCount);
  const { error } = useSelector((state) => state.userData);
  const [page, setPage] = useState(1);
  const [searchPage, setSearchPage] = useState(1);
  const itemsPerPage = 10;
  const timeoutRef = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [initalLoading, setInitialLoading] = useState(false); //true default

  const handleSearchChange = (event) => {
    const value = event.target.value;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setSearchText(value);
    }, 300);
  };

  const [loading, setLoading] = useState(true);


  const [rows, setRows] = useState([]);



  const handleNavigate = (userId) => {
    navigate(`/userProfile/${userId}`);
  };

  const avatars = (members) =>
    members.map(([image, name]) => (
      <Tooltip key={name} title={name} placeholder="bottom">
        <MDAvatar
          src={image}
          alt="name"
          sx={{
            border: ({ borders: { borderWidth }, palette: { white } }) =>
              `${borderWidth[2]} solid ${white.main}`,
            cursor: "pointer",
            position: "relative",

            "&:not(:first-of-type)": {
              ml: -1.25,
            },

            "&:hover, &:focus": {
              zIndex: "10",
            },
          }}
        />
      </Tooltip>
    ));



  const handleRows = () => {
    if (userData?.length > 0) {
      const rowsAPI = userData.map((user) => ({
        Image: (
          <MDBox display="flex" py={1}>
            {avatars([[user?.userProfiles?.[0]?.image, user.name]])}
          </MDBox>
        ),
        Name: capitalizeFirstLetter(user.name),
        Email: capitalizeFirstLetter(user.email),
        // <MDTypography variant="caption" color="text" fontWeight="medium">
        //   {user.email}
        // </MDTypography>
        Mobile: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {user.mobile}
          </MDTypography>
        ),
        date: formatDate(user.createdAt),
        Action: (
          <MDBox>
            <MDButton
              onClick={() => handleNavigate(user.userId)}
              size="small"
              variant="gradient"
              color="light"
            >
              <MDTypography style={{ fontSize: "13.5px", fontWeight: "bold" }} color="white">
                Visit Profile
              </MDTypography>
            </MDButton>
          </MDBox>
        ),
      }));

      setRows(rowsAPI);
      setLoading(true);
    } else {
      setRows([]);
      setLoading(true);
    }
  };

  const handleuserApiCall = async () => {
    try {
      dispatch(getUsersData({ page, limit: itemsPerPage }));
    } catch (e) {
      console.log("e: ", e);
    }
  };

  const columns = [
    { Header: "Image", accessor: "Image", width: "10%", align: "center", disableSortBy: true },
    { Header: "Name", accessor: "Name", align: "center" },
    { Header: "Email", accessor: "Email", align: "center" },
    { Header: "Contact Number", accessor: "Mobile", align: "center", disableSortBy: true },
    {
      Header: "Joined On",
      accessor: "date",
      align: "center",
      sortType: (rowA, rowB) => {
        const dateA = new Date(rowA.original.date);
        const dateB = new Date(rowB.original.date);
        return dateA - dateB;
      },
    },
    { Header: "Action", accessor: "Action", align: "center", disableSortBy: true },
  ];

  useEffect(() => {
    handleRows()
  }, [userData])

  useEffect(() => {
    handleuserApiCall();
  }, [page]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              {!initalLoading ? (
                <MDBox>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="light"
                    borderRadius="lg"
                    coloredShadow="light"
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", sm: "row" },
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 2,
                      p: 3,
                    }}
                  >
                    <MDBox
                      sx={{
                        flex: 1,
                        display: "flex",
                        justifyContent: { xs: "center", sm: "flex-start" },
                        mb: { xs: 2, sm: 0 },
                      }}
                    >
                      <MDTypography variant="h5" color="white">
                        {`Users`}
                      </MDTypography>
                    </MDBox>

                    <MDBox
                      sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: "center",
                        gap: { xs: 2, sm: 0 },
                        justifyContent: { xs: "center", sm: "flex-end" },
                      }}
                    >
                      {/* <MDBox
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          width: { xs: "100%", sm: "auto" },
                          mb: { xs: 2, sm: 0 },
                        }}
                      >
                        <TextField
                          onChange={handleSearchChange}
                          id="standard-bare"
                          variant="outlined"
                          placeholder="Search user"
                          sx={{
                            "& .MuiInputBase-input": {
                              color: "#ffffff",
                              width: { xs: "100%", sm: "240px" },
                            },
                          }}
                          InputProps={{
                            endAdornment: (
                              <IconButton>
                                <SearchOutlined color="white" />
                              </IconButton>
                            ),
                          }}
                        />
                      </MDBox> */}
                    </MDBox>
                  </MDBox>

                  <MDBox pt={3}>
                    {rows?.length > 0 ? (
                      <DataTable
                        table={{ columns, rows }}
                        isSorted={true}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        noEndBorder
                      />
                    ) : (
                      <MDBox sx={{ display: "flex", padding: "20px", justifyContent: "center" }}>
                        <MDTypography variant="caption" sx={{ fontSize: "20px" }}>
                          { !loading &&" No Users are present at this time." } 
                        </MDTypography>
                      </MDBox>
                    )}
                  </MDBox>

                  <MDBox display="flex" justifyContent="center" alignItems="center" mt={2} mb={3}>
                    <Pagination
                      count={Math.ceil(totalCount / itemsPerPage)}
                      page={searchText === "" ? page : searchPage}
                      onChange={(event, value) => {
                        {
                          searchText === "" ? setPage(value) : setSearchPage(value);
                        }
                      }}
                      color="light"
                      shape="rounded"
                      size="large"
                      sx={{
                        "& .MuiPaginationItem-root": {
                          "&:hover": {
                            backgroundColor: "#FC8954",
                          },
                        },
                        "& .MuiPaginationItem-previousNext": {
                          borderRadius: "8px",
                          border: "1px solid #ddd",
                        },
                      }}
                    />
                  </MDBox>
                </MDBox>
              ) : !error ? (
                <MDBox
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  width="100vw"
                  height="100vh"
                  position="fixed"
                  top={0}
                  left={0}
                >
                  <CircularProgress sx={{ color: "orange" }} size={54} />
                </MDBox>
              ) : (
                <MDBox
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  width="100vw"
                  height="100vh"
                  position="fixed"
                  top={0}
                  left={0}
                >
                  <MDTypography>Error Occured</MDTypography>
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default UserTable;
